<template>
  <footer class="footer">
    <div class="footer-top">
      <div class="language-section">
        <label>Language</label>
        <div class="select-wrapper">
          <select v-model="selectedLanguage" class="language-select">
            <option value="en">English</option>
            <!-- <option value="zh">中文</option> -->
            <!-- <option value="ar">العربية</option> -->
          </select>
        </div>
      </div>

      <div class="links-section">
        <div class="link-group">
          <h3
            class="cursor-pointer"
            @click="$router.push('/agreement/user-agreement')"
          >
            User Agreement
          </h3>
          <!-- <a href="#">Offline payment</a> -->
        </div>
        <div class="link-group">
          <h3
            class="cursor-pointer"
            @click="$router.push('/agreement/privacy-policy')"
          >
            Privacy Policy
          </h3>
          <!-- <a href="#">Charges</a> -->
        </div>
        <div class="link-group">
          <h3
            class="cursor-pointer"
            @click="$router.push('/agreement/account-deletion-statement')"
          >
            Account Deletion Statement
          </h3>
          <!-- <a href="#">Contact us</a> -->
        </div>
        <div class="link-group">
          <h3
            class="cursor-pointer"
            @click="$router.push('/agreement/cookie-statement')"
          >
            Cookie Statement
          </h3>
          <!-- <a href="#">Contact us</a> -->
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="copyright">Copyright ©2025 INSPAY</div>
      <div class="bottom-links">
        <!-- <a href="#">Website Terms of Use</a>
        <a href="#">Cookie Statement</a> -->
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterSection",
  data() {
    return {
      selectedLanguage: "en",
    };
  },
};
</script>

<style scoped>
.footer {
  background-color: #000;
  color: #fff;
  padding: 40px 60px 20px;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 40px;
}

.language-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.language-section label {
  font-size: 16px;
  color: #fff;
}

.select-wrapper {
  position: relative;
  width: 200px;
}

.select-wrapper::after {
  content: "";
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #fff;
  pointer-events: none;
}

.language-select {
  width: 100%;
  padding: 10px 15px;
  padding-right: 35px; /* 为箭头留出空间 */
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  appearance: none;
  cursor: pointer;
  transition: background-color 0.3s, border-color 0.3s;
}

.language-select:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.language-select:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.4);
  background-color: rgba(255, 255, 255, 0.2);
}

/* 自定义下拉菜单样式 */
.language-select option {
  background-color: #2c2c2c;
  color: #fff;
  padding: 10px;
}

.links-section {
  display: flex;
  gap: 80px;
}

.link-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.link-group h3 {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  margin: 0;
}

.link-group a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.link-group a:hover {
  color: #fff;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
}

.copyright {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.bottom-links {
  display: flex;
  gap: 30px;
}

.bottom-links a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.bottom-links a:hover {
  color: #fff;
}

@media (max-width: 768px) {
  .footer {
    padding: 20px;
  }

  .footer-top {
    gap: 20px;
    margin-bottom: 20px;
    padding-bottom: 20px;
  }

  .select-wrapper {
    width: 120px;
  }

  .language-section label {
    font-size: 12px;
  }

  .language-select {
    padding: 6px 8px;
    font-size: 12px;
  }

  .links-section {
    gap: 15px;
  }

  .link-group {
    gap: 8px;
  }

  .link-group h3 {
    font-size: 12px;
  }

  .link-group a {
    font-size: 10px;
  }

  .footer-bottom {
    justify-content: space-between;
    padding-top: 15px;
  }

  .copyright {
    font-size: 10px;
  }

  .bottom-links {
    gap: 15px;
  }

  .bottom-links a {
    font-size: 10px;
  }

  .select-wrapper::after {
    right: 10px;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #fff;
  }
}

@media (max-width: 480px) {
  .links-section {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
}
</style>
